import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { IState } from "../../../App/reducer";
import Checkbox from "../../../components/pages/CourseAuthor/Checkbox";
import * as selectors from "../../../selectors/selectors";
import { CheckboxDescription, FooterNote, SettingsInputItem } from "../../Common/Components/FormComponents";
import { Section as UnstyledSection, SectionTitle } from "../../Common/Styles/containers";

interface ILockPackageStateProps {
  isOrgAdmin: boolean;
}

interface ILockPackage {
  lockPackage: boolean;
  toggleLockPackage: (ev: React.MouseEvent<HTMLInputElement>) => void;
}

type LockPackageProps = ILockPackage & ILockPackageStateProps;

const Section = styled(UnstyledSection)`
  display: flex;
  flex-direction: column;
`;

const WarningSection = styled(Section)`
  border: 0.1rem solid ${({ theme }) => theme.colors.orangeWarning};
`;

const confirmationLockPackageMsg = (locked: boolean): string =>
  `Are you sure you want to ${locked ? "unlock" : "lock"} the package?`;

const LockPackage: React.FC<LockPackageProps> = props => {
  const { isOrgAdmin, lockPackage, toggleLockPackage } = props;
  const [customChecked, setCustomChecked] = React.useState(lockPackage);
  const toggleWarningMessage = (ev: React.MouseEvent<HTMLInputElement>) => {
    if (confirm(confirmationLockPackageMsg(lockPackage))) {
      setCustomChecked(!customChecked);
      toggleLockPackage(ev);
    }
  };
  return (
    <>
      <SectionTitle>Danger Zone</SectionTitle>
      {isOrgAdmin && (
        <WarningSection>
          <SettingsInputItem>
            <label>
              <Checkbox defaultChecked={lockPackage} onChange={toggleWarningMessage} />
              <CheckboxDescription>Lock the package</CheckboxDescription>
            </label>
          </SettingsInputItem>
          <p>
            <FooterNote>
              Locking the package prevents making accidental changes to a package once it has been rolled out. All
              patches to the package will fail, until the package has been unlocked.
            </FooterNote>
          </p>
        </WarningSection>
      )}
    </>
  );
};

const mapStateToProps = (state: IState): ILockPackageStateProps => ({
  isOrgAdmin: selectors.isOrgAdmin(state),
});

export default connect(mapStateToProps)(LockPackage);
